import React from "react";
import dayjs from "dayjs";
import "chart.js/auto";
import { Line } from "react-chartjs-2";
import { useGetSalesPlotDataQuery } from "state/api";
import Loader from "components/Loader";
import DatePickerComponent from "components/GraphDatePickerComponent";

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    colors: {
      enabled: true,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.54)",
      },
    },
    y: {
      grid: {
        display: false,
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.54)",
      },
    },
  },
  elements: {
    line: {
      tension: 0.3,
    },
  },
};

const SalesRangeGraph = () => {
  const [startDate, setStartDate] = React.useState(
    dayjs(new Date()).subtract(1, "month")
  );
  const [endDate, setEndDate] = React.useState(dayjs(new Date()));

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const { data: salesPlotData, isLoading } = useGetSalesPlotDataQuery({
    startDate: startDate.format("YYYY-MM-DD"),
    endDate: endDate.format("YYYY-MM-DD"),
  });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="flex flex-col justify-center align-middle">
          <DatePickerComponent
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
          />
          <Line
            data={{
              labels: salesPlotData?.labels || [],
              datasets: [
                {
                  label: "Sales Amount",
                  borderColor: "#2e7d32",
                  data: salesPlotData?.data || [],
                  fill: {
                    target: "origin",
                    above: "rgba(41,125,50,0.1)",
                  },
                },
              ],
            }}
            options={options}
          />
        </div>
      )}
    </>
  );
};

export default SalesRangeGraph;
